import React from 'react';
import { Box, Spinner } from '../../../../../components/Boneyard';

const LoadingIndicator = () => (
  <Box d={'flex'} justifyContent={'center'}>
    <Spinner size="large" inline={true} />
  </Box>
);

LoadingIndicator.displayName = 'LoadingIndicator';

export default LoadingIndicator;
